import React, { useState, useEffect, useContext } from 'react';
import Navbar from '../layout/navbar/navbar';
import Footer from '../layout/footer/footer';
import './home.css';
import Logo from '../assets/images/image.png';
import BlackProfile from '../assets/icons/black-profile.svg';
import Message from '../assets/icons/message.svg';
import Bag from '../assets/icons/bag.svg';
import { Divider } from 'primereact/divider';
import Profile from './profile/profile';
import Orders from './orders/orders';
import Comment from './comment/comment';

import NavContext from '../contexts/NavContext.jsx';
import Dotloader from './loader/dotloader';

function Home() {
  const [profile, setProfile] = useState(true);
  const [order, setOrder] = useState(false);
  const [comment, setComment] = useState(false);
  const [loading, setLoading] = useState(false); // Add this line for loading state

  const gotoProfile = () => {
    setComment(false);
    setOrder(false);
    setProfile(true);
  };

  const gotoOrder = () => {
    setComment(false);
    setOrder(true);
    setProfile(false);
  };

  const gotoComment = () => {
    setComment(true);
    setOrder(false);
    setProfile(false);
  };

  const { nav, setNav } = useContext(NavContext);

  useEffect(() => {
    if (nav === 'profile') {
      gotoProfile();
    }
    if (nav === 'comment') {
      gotoComment();
    }
    if (nav === 'order') {
      gotoOrder();
    }
  }, [nav]);

  // Set loading to true when profile is selected
  useEffect(() => {
      setLoading(true); // Show loader
  }, [profile,comment,order]);

  // Function to handle when profile data is loaded
  const handleProfileLoad = () => {
    setLoading(false); // Hide loader once data is loaded
  };
 const handleOrderLoad= () => {
  setLoading(false); // Hide loader once data is loaded
};
const handleCommentLoad= () => {
  setLoading(false); // Hide loader once data is loaded
};
  return (
    <div className='home-container'>
      {/* Show Dotloader while loading */}
      {loading && <Dotloader />}
      <div className='home-body'>
        <div className='header'>
        </div>
        <div>
          <div className='body-page'>
            <Navbar />
            <div className='tab-body'>
              {profile && <Profile onProfileLoad={handleProfileLoad} />} {/* Pass onProfileLoad prop */}
              {order && <Orders onLoad={handleOrderLoad}/>}
              {comment && <Comment onLoad={handleCommentLoad}/>}
            </div>
          </div>
        </div>

        <div className='tab-menu web-menu'>
          <div className="menu-card">
            <div className='img-box text-center'>
              <img src={Logo} alt="" width={120}/>
            </div>
            <Divider />
            <div className='menu-items '>
              <div className={`item ${profile ? 'active' : ''}`} onClick={gotoProfile}>
                <img className='ml-2' src={BlackProfile} alt="" />
                پروفایل من
              </div>
              <div className={`item ${order ? 'active' : ''}`} onClick={gotoOrder}>
                <img className='ml-2' src={Bag} alt="" />
                سفارشات من
              </div>
              <div className={`item ${comment ? 'active' : ''}`} onClick={gotoComment}>
                <img className='ml-2' src={Message} alt="" />
                نظرات من
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="home-footer">
        <Footer />
      </div>
    </div>
  );
}

export default Home;
